import './info-view.css';

const InfoView = ({ text }: { text: string }) => {
  return (
    <div className="cometchat-calls-info-view-container">
      <p className="cometchat-calls-info-view-message">{text}</p>
    </div>
  );
};

export default InfoView;
